import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="border-t border-line py-10">
      <div className="mx-auto max-w-7xl px-5 md:px-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div>
          <Logo />
          <p className="text-mid text-sm mt-3 max-w-sm">
            The garage wall for your fleet's paperwork — MOTs, council tests and road tax on
            one dashboard.
          </p>
        </div>
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-low">
          MOT <span className="text-ember">/</span> Council <span className="text-ember">/</span> Road tax — {new Date().getFullYear()}
        </p>
      </div>
    </footer>
  );
}
